import './style.scss'
import Layer from '../../Shared/Layer'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import Button from '../../Shared/Form/Button'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { BUTTON_MIN_WIDTH } from '../../Shared/Form/Button/constants'

const ErrorNoticeOverlay = ({ header, subheader, onClose, icon }) => {
  const { t } = useTranslation()
  const backgroundImage = icon ? `url(${icon})` : undefined
  return (
    <Layer
      type="center"
      size="small"
      id={'error-notice'}
      show={true}
      onHideClick={onClose}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="error-notice-overlay"
      closeOnEsc={true}
    >
      <Container fluid>
        <Row style={{ alignItems: 'center' }}>
          <Col xs={4}>
            <span className="error-notice-overlay__icon" style={{ backgroundImage: backgroundImage }}></span>
          </Col>
          <Col xs={8}>
            <div className="error-notice-overlay__header">{header || t('ERROR_NOTICE_HEADER')}</div>
            <div className="error-notice-overlay__subheader">
              {subheader || t('ERROR_NOTICE_SUB_HEADER')}
            </div>
          </Col>
        </Row>
        <Row>
          <br/>
        </Row>
        <Row>
          <Button
            style={{ textTransform: 'uppercase' }}
            onClick={onClose}
            align="center"
            minWidth={BUTTON_MIN_WIDTH}
          >
            {t('BUTTON_OK')}
          </Button>
        </Row>
      </Container>
    </Layer>
  )
}

ErrorNoticeOverlay.propTypes = {
  header: PropTypes.string,
  subheader: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  icon: PropTypes.object,
}

export default ErrorNoticeOverlay
